import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  const params = new URLSearchParams(window.location.search);
  const fileParam = params.get('file');
  console.log('fileParam:', fileParam); // Add this line to log the fileParam
  root.render(
    <React.StrictMode>
      <App fileParam={fileParam ?? undefined} />
    </React.StrictMode>
  );
}